export default class AccessTokenChangedError {}
